// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MobileFilledSvg from "@fishx/icons-svg/es/asn/MobileFilled";
import FishxIcon from '../components/FishxIcon';

var MobileFilled = function MobileFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MobileFilledSvg
  }));
};

MobileFilled.displayName = 'MobileFilled';
export default React.forwardRef(MobileFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MobileFilled.js
// module id = 3147
// module chunks = 0